<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <p class="title">Con fecha de {{ reclamacionFecha }} a las {{ reclamacionFechaHora }}, se realizó la solicitud
            de reclamación,
            con la siguiente información:</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <template v-if="media.sm">
            <el-descriptions :column="1" border direction="vertical">
              <el-descriptions-item content-class-name="pp-el-descriptions-item">
                <template slot="label">
                  <span class="el-icon-question"></span>
                  ¿Se presentó reclamación?
                </template>
                <template v-if="presentaReclamacion === 1">
                  <span class="el-icon-circle-check"></span>
                  <span data-cy="is-claims">Si</span>
                </template>
                <template v-else>
                  <span class="el-icon-circle-close"></span>
                  <span data-cy="is-claims">No</span>
                </template>
              </el-descriptions-item>
              <template v-if="presentaReclamacion === 1">

                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-bell"></span>
                    Estado de reclamación
                  </template>
                  <el-tag :type="estadoTag" data-cy="claim-state">{{ estadoReclamacion }}</el-tag>
                </el-descriptions-item>

                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-download"></span>
                    Documento Adjunto
                  </template>
                  <template v-if="!!document">
                    <el-link @click="downloadDocument" class="downloadAttach">Descargar
                      <em class="el-icon-download el-icon--right"></em>
                    </el-link>
                  </template>
                  <template v-else>
                    <span class="noAttach">Sin documentos adjuntos.</span>
                  </template>
                </el-descriptions-item>

                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-document"></span>
                    Motivos de Rechazo
                  </template>
                  <span data-cy="claim-reffuse">{{ motivosRechazo }}</span>
                </el-descriptions-item>
              </template>
            </el-descriptions>
          </template>
          <template v-else>
            <el-descriptions :column="6" border>
              <el-descriptions-item content-class-name="pp-el-descriptions-item" :span="2">
                <template slot="label">
                  <span class="el-icon-question"></span>
                  ¿Se presentó reclamación?
                </template>
                <template v-if="presentaReclamacion === 1">
                  <span class="el-icon-circle-check"></span>
                  <span data-cy="is-claims">Si</span>
                </template>
                <template v-else>
                  <span class="el-icon-circle-close"></span>
                  <span data-cy="is-claims">No</span>
                </template>
              </el-descriptions-item>
              <template v-if="presentaReclamacion === 1">

                <el-descriptions-item content-class-name="pp-el-descriptions-item" :span="2">
                  <template slot="label">
                    <span class="el-icon-bell"></span>
                    Estado de reclamación
                  </template>
                  <el-tag :type="estadoTag" data-cy="claim-state">{{ estadoReclamacion }}</el-tag>
                </el-descriptions-item>

                <el-descriptions-item content-class-name="pp-el-descriptions-item" :span="2">
                  <template slot="label">
                    <span class="el-icon-download"></span>
                    Documento Adjunto
                  </template>
                  <template v-if="!!document">
                    <el-link @click="downloadDocument" class="downloadAttach">Descargar
                      <em class="el-icon-download el-icon--right"></em>
                    </el-link>
                  </template>
                  <template v-else>
                    <span class="noAttach" data-cy="claim-no-attach">Sin documentos adjuntos.</span>
                  </template>
                </el-descriptions-item>

                <el-descriptions-item content-class-name="pp-el-descriptions-item" :span="6">
                  <template slot="label">
                    <span class="el-icon-document"></span>
                    Motivos de Rechazo
                  </template>
                  <span  data-cy="claim-reffuse">{{ motivosRechazo }}</span>
                </el-descriptions-item>
              </template>
            </el-descriptions>
          </template>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {Descriptions, DescriptionsItem, Link, Tag} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import moment from "moment-timezone";

export default {
  name: "RevisionSolicitudReclamacionVer",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
    [Link.name]: Link,
  },
  props: {
    reclamacionFecha: String,
    reclamacionFechaHora: String,
    presentaReclamacion: Number,
    estadoReclamacionCodigo: Number,
    estadoReclamacion: String,
    motivosRechazo: String,
    disabled: {
      type: Boolean,
      default: true
    },
    document: String
  },
  mixins: [ScreenSizeMixin],
  computed: {
    estadoTag() {
      return this.estadoReclamacionCodigo === 1 ? 'success' : 'danger'
    }
  },
  methods: {
    downloadDocument() {
      const data = this.document
      let link = document.createElement('a')
      link.href = data
      const date = moment().format('YYYYMMDDhhmmss')
      link.download = `documento-${date}`
      link.click();
    }
  }
}
</script>
